import { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Form, message, Modal } from 'antd';

import { event } from '../event';
import {
  checkPhoneService,
  loginOutService,
  mergePhoneService,
  sendCodePhoneByRegService,
  sendCodePhoneByRegService2,
  setZhiyinPhoneBindService,
  unbindUser,
} from '../services';
import {
  autoCompletePhone,
  clearAllLocal,
  delCookieToken,
  getCookieToken,
  getLocalZhiyinUser,
  getNodeId,
  onCloseLoginModal,
  setCookieToken,
} from '../utils';
import customLocalStorgeEventListener from '../utils/timeout';
import AlertText from './AlertText';
import FormBindPhone from './FormBindPhone';
import { useCountDownCustom } from './hooks';

import './index.less';

const ModalTitle = (props: any) => (
  <div className={'loginHeader'}>
    <div></div>
    {props.onClose && (
      <div className={'closeIcon'} onClick={props.onClose}>
        <CloseOutlined />
      </div>
    )}
  </div>
);

// 绑定手机号
const BindPhoneApp = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showBind, setShowBind] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useState(() => {
    event.on('event-showBindPhone', (bool, params) => {
      setIsModalOpen(bool);
      setShowAlert((pre) => params?.showAlert || pre);
    });
  });

  const onClickBind = () => {
    setShowBind(false);
  };

  // 放弃并退出登录
  const onClickLogout = async () => {
    setShowBind(false);
    setIsModalOpen(false);

    // 退出登录
    await loginOutService({});
    // 退出成功回
    props?.onLogoutSuccess?.();
    clearAllLocal(); // 清空缓存
    onCloseLoginModal(); //登录信息处理
    delCookieToken();
  };

  const onCloseFormModal = () => {
    if (showAlert === true) {
      setShowBind(true);
    } else {
      setIsModalOpen(false);
    }
  };

  const onCloseTextModal = () => {
    setShowBind(false);
  };

  // formProps
  const [form] = Form.useForm();
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true); // 短信
  const [loadingBtn, setLoadingBtn] = useState(false);

  const [targetToken, setTargetToken] = useState('');
  const [targetNickname, setTargetNickname] = useState('');
  const [targetPhone, setTargetPhone] = useState('');
  const [targetUid, setTargetUid] = useState('');
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);

  let client_id = getNodeId();

  const { codeBtnDisabled, btnContent, enable, setEnable, startCountDown } = useCountDownCustom();

  // 错误提示
  const showErrorInfo = (content?: any) => {
    message.error({
      content: content || '绑定手机失败',
      key: 'bindPhoneError',
    });
  };

  // 校验手机状态
  const checkPhoneStatus = async (value: any) => {
    const payload = { phone: value, client_id };
    const result = await checkPhoneService(payload);
    const status = result?.data?.isExist ? true : false;
    if (status) {
      const errorText = (
        <span>
          该手机号已被占用，请更换手机号或使用该手机号
          <span
            className="checkText aHref"
            onClick={() => {
              onClickLogout();
            }}
          >
            直接登录》
          </span>
        </span>
      );
      form.setFields([{ name: 'username', errors: [errorText] }]);
    }
    return status;
  };

  // 发送短信验证
  const onSendCode = async () => {
    const formValues = form.getFieldsValue();
    const username = autoCompletePhone(formValues?.username); // 手机号 +86
    const status = await checkPhoneStatus(username); // 当前手机号是否已被绑定在其他账号下
    if (status) return;

    const payload = { phone: username };
    // let data = await (status
    //   ? sendCodePhoneByRegService2(payload)
    //   : sendCodePhoneByRegService(payload));
    const data = await sendCodePhoneByRegService(payload);

    if (data?.error) {
      const msg = data.msg || data.error;
      if (msg === '60秒内不能发送多次验证码' || msg === '已经发送过验证码，请稍后再试') {
        message.error('60秒内不能发送多次验证码');
      } else {
        message.error('验证码发送失败，请稍候重试!');
      }
    } else {
      // 开始倒计时
      startCountDown();
      setEnable(false);
      message.success('验证码发送成功，请查收!');
    }
  };

  const onFinish = async (values: any) => {
    setLoadingBtn(true);
    const { username, code } = values;
    const phone = autoCompletePhone(username); // +86
    const status = await checkPhoneStatus(phone); // 当前手机号是否已被绑定在其他账号下
    if (status) return setLoadingBtn(false);
    const payload = {
      code,
      username: phone, // +86
      category: 2,
    };

    const res = await setZhiyinPhoneBindService(payload);
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    setLoadingBtn(false);
    if (res?.data?.token) {
      // 需要合并账号
      // let { nickname, token, user_id } = res.data;
      // setTargetToken(token);
      // setTargetNickname(nickname);
      // setTargetPhone(phone);
      // setTargetUid(user_id);
      // if (showAlert) {
      //   // 当前账号为绑定手机号
      //   setVisible1(true);
      // } else {
      //   setVisible2(true);
      // }
    } else {
      handleBindData(res); // 绑定数据处理
    }
  };

  async function handleBindData(result: any) {
    if (!result) {
      // 后端 api 异常统一提示
      showErrorInfo();
      props.bindPhoneSuccess?.(showAlert, false, '服务端错误');
      return;
    }
    // 绑定是失败
    if (result?.resultDescription !== 'SUCCESS') {
      let errorText = result?.resultDescription || '绑定手机失败';
      showErrorInfo(errorText);
      props.bindPhoneSuccess?.(showAlert, false, errorText);
      return;
    }

    // 解绑手机号
    const userInfo = getLocalZhiyinUser();
    const aminer_phones = userInfo?.amienr_phones?.filter(Boolean);
    if (aminer_phones?.length > 0) {
      const res = await Promise.all(
        aminer_phones.map((item) => {
          return unbindUser({
            kind: 3, // 1: 2:邮箱 3:手机号
            kindValue: item,
          });
        }),
      );
      if (res.some((item) => item.resultDescription !== 'SUCCESS')) {
        // 报错
        props?.bindEmailSuccess?.(false, '绑定失败');
        showErrorInfo('绑定失败，请稍后再试');
        setLoadingBtn(false);
        return;
      }
    }
    message.success(`绑定手机成功`);

    // 添加定时器，防止页面刷新无提示
    setTimeout(() => {
      setShowBind(false);
      setIsModalOpen(false);
      props.bindPhoneSuccess?.(showAlert, true); // 修改成功回调
    }, 1000);
  }

  const onFieldsChange = (fields: any, allFields: any) => {
    let isDisabledCheck = false;

    for (let fieldItem of allFields) {
      if (fieldItem.name[0] === 'username') {
        if (fieldItem.errors?.length) {
          setEnable(false);
        } else {
          setEnable(true);
        }
      }
      if (fieldItem?.name[0] !== 'agreement') {
        // 不考虑协议
        if (fieldItem?.errors?.length > 0 || !fieldItem?.value) {
          //校验失败或者值为空
          isDisabledCheck = true;
          break;
        }
      }
    }

    setIsDisabledSubmit(isDisabledCheck);
  };

  const formProps = {
    form,
    onFinish,
    onFieldsChange,
    enable,
    codeBtnDisabled,
    onSendCode,
    btnContent,
    isDisabledSubmit,
    loadingBtn,
  };

  const onCancel = () => {
    setVisible1(false);
    setVisible2(false);
    setVisible3(false);
  };

  const [mergeAccountLoading, setMergeAccountLoading] = useState(false);
  // 合并账号
  const onMergeAccount = async () => {
    setMergeAccountLoading(true);
    let dest = targetToken,
      src = getCookieToken();

    const res = await mergePhoneService({
      dest,
      src,
    });
    setMergeAccountLoading(false);
    if (res?.resultCode === 'OK') {
      message.success('合并帐号成功！');
      setTimeout(() => {
        location.reload();
      }, 1000);
    } else {
      message.error('合并帐号失败，请稍后重试！');
    }
  };

  const getFooter = (isMerge = false) => {
    return (
      <div className="modal_buttons">
        <Button
          onClick={() => {
            setCookieToken(targetToken);
            location.reload();
          }}
        >
          使用该手机号登录
        </Button>
        <Button
          onClick={() => {
            onCancel();
            form.resetFields();
          }}
        >
          更换手机号
        </Button>
        {isMerge && (
          <Button type="primary" loading={mergeAccountLoading} onClick={() => setVisible3(true)}>
            合并账号
          </Button>
        )}
      </div>
    );
  };

  const mergeName1 = mergeNameFormat(getLocalZhiyinUser()?.name) || getLocalZhiyinUser()?.email;
  const mergeName2 = mergeNameFormat(targetNickname) || targetPhone;

  return (
    <>
      <Modal
        maskClosable={false}
        width={props?.width || 480}
        destroyOnClose={true}
        centered={true}
        closable={false}
        open={isModalOpen}
        wrapClassName={'loginModalWrap'}
        footer={null}
        title={<ModalTitle onClose={onCloseFormModal} />}
      >
        <>
          {showAlert == true && <AlertText text="为保证账户安全，请绑定手机号后继续使用。" />}
          <FormBindPhone {...formProps} />
        </>
      </Modal>

      {/*文案提示*/}
      <Modal
        maskClosable={false}
        width={props?.width || 480}
        destroyOnClose={true}
        centered={true}
        closable={false}
        open={showBind && showAlert == true}
        wrapClassName={'loginModalWrap'}
        footer={null}
        title={<ModalTitle onClose={onCloseTextModal} />}
      >
        <div className={'bindPhoneModalTipcontent'}>
          <div className={'bindText'}>
            未绑定手机号的账号将无法继续使用该平台提供的服务，请确认是否放弃绑定手机号？
          </div>
          <div className={'bindGroup'}>
            <Button size="large" onClick={onClickLogout}>
              放弃并退出登录
            </Button>
            <Button size="large" type="primary" onClick={onClickBind}>
              继续绑定
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        wrapClassName={'loginModalWrap'}
        open={visible1}
        width={480}
        footer={null}
        closable={false}
        title={<ModalTitle />}
      >
        <div className="modal_h2">手机号绑定冲突提醒</div>
        <div className="modal_h2_desc">
          该手机号已被其他账号绑定，暂无法绑定到当前账号。如果想继续绑定该手机号，会强行对两个账号信息合并。如果不想合并账号，可以选择更换待绑定手机号或使用该手机号直接登录。
        </div>
        {getFooter(true)}
      </Modal>

      <Modal
        wrapClassName={'loginModalWrap'}
        width={480}
        open={visible2}
        footer={null}
        closable={false}
        title={<ModalTitle />}
      >
        <div className="modal_h2">手机号绑定冲突提醒</div>
        <div className="modal_h2_desc">
          该手机号已被其他账号绑定，暂无法绑定到当前账号。请更换待绑定手机号或使用该手机号直接登录。
        </div>
        {getFooter()}
      </Modal>

      <Modal
        wrapClassName={'loginModalWrap'}
        width={480}
        open={visible3}
        footer={null}
        closable={false}
        title={<ModalTitle />}
      >
        <div className="modal_h2">合并账号</div>
        <div className="modal_h2_desc">
          合并账号后，学者<span>{mergeName1}</span>
          的历史浏览记录、搜索记录、问答记录、上传的文件等都会丢失，权限信息会合并到账号
          <span>{mergeName2}</span>上，是否确认合并<span>{mergeName1}</span>和
          <span>{mergeName2}</span>两个账号？
        </div>
        <div className="modal_buttons">
          <Button onClick={() => setVisible3(false)}>取消</Button>
          <Button type="primary" loading={mergeAccountLoading} onClick={onMergeAccount}>
            确认
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default BindPhoneApp;

function mergeNameFormat(name: string) {
  if (name?.length === 1) {
    return name;
  }
  if (name?.length > 1) {
    return name.at(0) + '**' + name.at(-1);
  }
}
